import { useRejectSchoolInvitationMutation } from '@/types/vue-apollo-helpers';

export function useRejectInvitation() {
  const { mutate: rejectInvitation, loading, error, onDone } = useRejectSchoolInvitationMutation();

  return {
    rejectInvitation,
    loading,
    error,
    onDone,
  };
}
